import { Component, ChangeDetectorRef, OnInit, OnDestroy } from '@angular/core';

import { BreadcrumbService, Breadcrumb } from '../breadcrumb.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'uex-breadcrumb',
  templateUrl: './breadcrumb.component.html',
  host: {
    class: 'uex-breadcrumb'
  }
})
export class BreadcrumbComponent implements OnInit, OnDestroy {

  constructor(
    private _changeDetectorRef: ChangeDetectorRef,
    private _breadcrumbService: BreadcrumbService
  ) { }

  private _change_subscription: Subscription;

  public ngOnInit() {
    this._change_subscription = this._breadcrumbService.onChange.subscribe(() => {
      this._changeDetectorRef.detectChanges();
    });
  }

  public ngOnDestroy() {
    if (this._change_subscription) { this._change_subscription.unsubscribe(); }
  }

  public get breadcrumbs(): Breadcrumb[] {
    return this._breadcrumbService.breadcrumbs;
  }

  public get visible(): boolean {
    return this._breadcrumbService.visible;
  }

  public getLink(breadcrumb: Breadcrumb) {
    return breadcrumb.url;
  }
}
